import { Formatters, Messages } from '../../codegen/Localize';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { FlowBasicInfo } from '../../ts/models/FlowInfo';
import { RunFlowOnOutputStepsNotification } from '../../ts/services/RunFlowOnOutputStepsNotification';
import { Flows } from '../resources/Flows';

export namespace RunFlowOnOutputStepsAction {
  export function dialog(
    flow: FlowBasicInfo,
    outputIds: string[],
    isIncremental: boolean
  ): Promise<any> {
    const dialogBody = Messages.runFlowsOnOutputStepsPrompt({
      ITEM_COUNT: outputIds.length,
      ITEM_COUNT_LOC: Formatters.formatCount(outputIds.length)
    });

    const dialogInstance = openReactConfirmationDialog<void, IResult>({
      title: Messages.runNow(),
      message: dialogBody,
      dialogWidth: TabDialogWidth.width375px,
      paramsForAction: undefined,
      actionName: Messages.runNowConfirmButton(),
      action: () => Flows.runFlowOnOutputSteps(flow.id, outputIds, isIncremental),
    });

    dialogInstance.result.then((result: IResult) => {
      RunFlowOnOutputStepsNotification.notify(result, flow, outputIds.length);
    });

    return Promise.resolve(dialogInstance.result);
  }
}
